import { Trans } from '@lingui/react/macro';
import { Box, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useSearchableMenu } from './SearchableMenuContext';
export function SearchMenuEmptyState(props) {
    const { children } = props;
    const { searchString } = useSearchableMenu();
    return (<Box alignItems="center" justifyContent="center" flexDirection="column" gap="md" py="2xl">
      <Falcon icon="magnifying-glass" $size={16} $color="gray.700"/>
      <Typography $color="gray.500">
        {searchString.length > 0 ? (<Trans comment="Searchable menu empty state">No results for {searchString}</Trans>) : (<Trans comment="Searchable menu empty state">Search to display results</Trans>)}
      </Typography>
      {children}
    </Box>);
}
